import { useEffect, useState, useContext, useMemo } from "react";
import dragula from "dragula";
import { AppContext } from "../../Context/Context";
import { Table } from "antd";

const DraggableComponent = ({ id, draggableItems }) => {
  const [dragItems, setDragItems] = useState(draggableItems);
  const [isDragEnabled, setIsDragEnabled] = useState(false);

  const {
    setDraggedItems,
    setWareHouseDraggedItems,
    showSaveDiscardLayout,
    isDefaultLayoutSelected,
    setWarehouseTempOrder,
  } = useContext(AppContext);

  const isWarehouseTable = useMemo(() => id === "warehouse-table-id", [id]);

  // Sync draggableItems with local dragItems
  useEffect(() => {
    setDragItems(draggableItems);
  }, [draggableItems]);

  // Enable/Disable drag based on context flags
  useEffect(() => {
    setIsDragEnabled(!isDefaultLayoutSelected && showSaveDiscardLayout);
  }, [isDefaultLayoutSelected, showSaveDiscardLayout]);

  // Push reordered data to global context
  useEffect(() => {
    if (isWarehouseTable) {
      setWareHouseDraggedItems(dragItems);
      setWarehouseTempOrder(dragItems.map((item) => item.key));
    } else {
      setDraggedItems(dragItems);
    }
  }, [dragItems, isWarehouseTable]);

  // Get drag/drop container based on table id
  const getContainer = () =>
    document.getElementById(id)?.getElementsByClassName("ant-table-tbody")[0];

  const getIndexInParent = (el) =>
    Array.from(el.parentNode.children).indexOf(el);

  const handleReorder = (from, to) => {
    setDragItems((prev) => {
      const updated = [...prev];
      const [moved] = updated.splice(from, 1);
      updated.splice(to, 0, moved);
      return updated;
    });
  };

  // Dragula Setup
  useEffect(() => {
    const container = getContainer();
    if (!container) return;

    let dragStartIndex;

    const drake = dragula([container], {
      moves: (el) => {
        if (!isDragEnabled) return false;
        dragStartIndex = getIndexInParent(el);
        return true;
      },
    });

    drake.on("drop", (el) => {
      const dragEndIndex = getIndexInParent(el);
      handleReorder(dragStartIndex, dragEndIndex);
    });

    return () => {
      if (typeof drake.destroy === "function") {
        drake.destroy();
      }
    };
  }, [id, isDragEnabled]);

  const columns = [
    {
      title: "Component",
      dataIndex: "component",
      key: "component",
    },
  ];

  return (
    <Table
      id={id}
      columns={columns}
      pagination={false}
      dataSource={dragItems}
    />
  );
};

export default DraggableComponent;
